import * as tslib_1 from "tslib";
import mailStore from 'owa-mail-store/lib/store/Store';
import { LocalLieState } from 'owa-mail-store/lib/store/schema/LocalLieState';
export default function doesConversationHaveDrafts(tableConversationRelation) {
    var e_1, _a;
    try {
        for (var _b = tslib_1.__values(tableConversationRelation.draftItemIds), _c = _b.next(); !_c.done; _c = _b.next()) {
            var draftItemId = _c.value;
            var draftMessage = mailStore.items.get(draftItemId);
            var nodeId = draftMessage ? draftMessage.InternetMessageId : null;
            var node = mailStore.conversationNodes.get(nodeId);
            if (!node || node.localLieState == LocalLieState.None) {
                // If the draft item is new enough to not yet be in the store or belong to a node, the node will be null and this is a genuine draft.
                // If the draft item does belong to a node, and the node's local lie state is None, this is a genuine draft.
                // In either case, return true and stop checking draftItemIds.
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // If none of the draft items met the above criteria, return false.
    return false;
}
//# sourceMappingURL=doesConversationHaveDrafts.js.map